<template>
  <div class="api-list">
    <div class="api-list-head">
      接口列表 <span class="count">({{ total }})</span>
    </div>
    <div class="api-list-search">
      <input type="text" v-model="keyword" placeholder="搜索接口名称 / ID" />
    </div>

    <div v-if="loading" class="api-list-empty">接口加载中…</div>
    <template v-else>
      <div v-for="cat in visibleCats" :key="cat.dimId">
        <div class="api-cat" @click="toggle(cat)">
          <span>{{ cat.dimName }}</span>
          <span class="count">({{ cat.intfNum || cat.intfList.length }})</span>
        </div>
        <template v-if="isOpen(cat)">
          <div
            v-for="api in cat.intfList"
            :key="api.id"
            class="api-item"
            :class="{ active: String(api.id) === String(activeId) }"
            @click="$emit('select', { api: api, cat: cat })"
          >
            <span>{{ api.name }}</span>
            <span class="api-item-id">{{ api.id }}</span>
          </div>
        </template>
      </div>
      <div v-if="!visibleCats.length" class="api-list-empty">没有匹配的接口</div>
    </template>
  </div>
</template>

<script>
/* 左侧接口列表（搜索 + 分类折叠 + 当前项高亮）
   结构与交互形态参考 website-handoff/js/api-test.js 的 DSSApiList；
   分类与接口数据由父页面通过 portal/api/dim/interface/detail 获取后传入，
   本组件不发起任何请求。 */
export default {
  name: 'ApiList',
  props: {
    dims: { type: Array, default: () => [] },
    total: { type: Number, default: 0 },
    activeId: { type: [String, Number], default: '' },
    loading: { type: Boolean, default: false }
  },
  data() {
    return {
      keyword: '',
      // 用户手动展开/收起过的分类：dimId -> bool
      toggled: {}
    };
  },
  computed: {
    kw() {
      return this.keyword.trim().toLowerCase();
    },
    searching() {
      return !!this.kw;
    },
    visibleCats() {
      if (!this.searching) return this.dims;
      const kw = this.kw;
      return this.dims
        .map(cat => {
          const intfList = (cat.intfList || []).filter(
            it =>
              String(it.name || '').toLowerCase().indexOf(kw) > -1 ||
              String(it.id || '').toLowerCase().indexOf(kw) > -1
          );
          return Object.assign({}, cat, { intfList: intfList });
        })
        .filter(cat => cat.intfList.length);
    },
    activeCatId() {
      const hit = this.dims.filter(cat =>
        (cat.intfList || []).some(it => String(it.id) === String(this.activeId))
      )[0];
      return hit ? hit.dimId : '';
    }
  },
  watch: {
    // 切换接口时保证其所在分类展开
    activeId() {
      if (this.activeCatId) this.$set(this.toggled, this.activeCatId, true);
    }
  },
  methods: {
    isOpen(cat) {
      // 搜索时全部展开；否则默认展开当前接口所在分类
      if (this.searching) return true;
      if (this.toggled[cat.dimId] !== undefined) return this.toggled[cat.dimId];
      return String(cat.dimId) === String(this.activeCatId);
    },
    toggle(cat) {
      this.$set(this.toggled, cat.dimId, !this.isOpen(cat));
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ApiList.vue